import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  ContentChildren,
  QueryList,
  TemplateRef,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';

import { AppTemplateDirective } from 'app/directive';

import { DataService } from 'app/services';

@Component({
  selector: 'app-divider-dropdown',
  templateUrl: './app-divider-dropdown.component.html',
  styleUrls: ['./app-divider-dropdown.component.scss'],
})
export class AppDividerDropdownComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() text: string = 'Save';
  @Input() fontSize: number = 12;
  @Input() styleClass: string = 'app-divider-dropdown-btn secondary';

  @Output() appShow = new EventEmitter<any>();
  @Output() appHide = new EventEmitter<any>();

  @ViewChild('dividerDropdownContainer')
  dividerDropdownContainer: ElementRef;

  @ContentChildren(AppTemplateDirective) templates: QueryList<any>;

  isDropDownVisible: boolean = false;
  itemTemplate: TemplateRef<any>;
  overlayTemplate: TemplateRef<any>;
  clickOutsideListener: any = null;

  constructor(private cdr: ChangeDetectorRef, private dataService: DataService) {}

  ngOnInit() {
    this.clickOutsideListener = this.dataService.getClickEvent().subscribe((target) => {
      if (this.dividerDropdownContainer.nativeElement.contains(target)) {
      } else {
        this.isDropDownVisible = false;
      }
    });
  }

  ngAfterViewInit() {
    this.getCustomTemplate();
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.clickOutsideListener) {
      this.clickOutsideListener.unsubscribe();
    }
  }

  showDropdown() {
    this.appShow.emit();
    this.isDropDownVisible = !this.isDropDownVisible;
  }

  closeDropdown = () => {
    this.appHide.emit();
    this.isDropDownVisible = false;
  };

  /** get all the custom templates */
  getCustomTemplate() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'item':
          this.itemTemplate = item.template;
          break;
        case 'dropdown-overlay':
          this.overlayTemplate = item.template;
          break;
      }
    });
  }
}
